<div class="request-home">
  <div class="request-home__bulk-bar">
    <div class="request-home__bulk-copy">
      <strong>{{ selectedRequestIds.length }} selected</strong>
      <span>Select confirmed requests to start packing and shipping.</span>
    </div>
    <app-button
      type="button"
      variant="secondary"
      [disabled]="selectedRequestIds.length === 0"
      (click)="createShipmentFromSelection()">
      Create Shipment
    </app-button>
  </div>
  <app-table
    [columns]="requestColumns"
    [data]="requestState.data()"
    [config]="requestConfig"
    [pagination]="requestPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
    (selectionChange)="onSelectionChange($event)"
    (dateRangeChange)="onDateRangeChange($event)"></app-table>

  <ng-template #requestExpandedRow let-request>
    <app-request-expanded-row [request]="request"></app-request-expanded-row>
  </ng-template>
</div>
